import { FullStory, init, isInitialized } from '@fullstory/browser';

export function initializeFullStory() {
	if (typeof window === 'undefined') return;

	const orgId = process.env.NEXT_PUBLIC_FULLSTORY_ORG_ID;

	if (!orgId) {
		// biome-ignore lint/suspicious/noConsole: necessary logging
		console.warn('FullStory is not configured. Missing org ID.');
		return;
	}

	if (orgId.includes('__REPLACE_WITH_')) {
		// biome-ignore lint/suspicious/noConsole: necessary logging
		console.warn('FullStory is not configured with valid credentials.');
		return;
	}

	init({ orgId });
}

export function identifyFullStoryUser(
	uid: string,
	displayName: string,
	email: string,
) {
	if (!isInitialized()) return;

	FullStory.identify(uid, { displayName, email });
}
